import { DisclaimerDialogCms } from '@cerifi/ui/cms/disclaimer-dialog/disclaimer-dialog-cms'

import { DisclaimerDialog } from '../../../__generated/graphql.types'

const Disclaimer = ({ content }: { content: DisclaimerDialog }) => {
  return (
    <DisclaimerDialogCms
      id={content.sys.id}
      buttonText={content.buttonText as string}
      dialogText={content.dialogText}
    />
  )
}

export default Disclaimer
